export interface TextAreaProps {
    value: string;
    onChange: (val: string) => void;
    invalid?: boolean;
}

export const TextArea: React.FC<TextAreaProps> = (props) => {
    return (
        <textarea value={props.value} onChange={(v) => props.onChange(v.target.value)} className={`${props.invalid ? "border-red-500 border-[1px]" : ""} h-[100px] rounded-xl shadow-main outline-none p-3 w-full`} spellCheck={false}/>
    )
}